import AxiosInterceptor from "api/interceptor";

const smtp = new AxiosInterceptor();

export default {
  getMailSetting() {
    return smtp.get("/smtp/email-config");
  },
  postTestMail(data) {
    return smtp.post("/smtp/testing-email", data);
  },
  updateEmailConfig(data) {
    return smtp.put("/smtp/email-config", data);
  },
  cancelTestingMail() {
    return smtp.put("/smtp/cancel-testing");
  },
};
